import { AnalyticsConfiguration } from './analytics-configuration';
import { interactionEvent, pageViewEvent, selfServeStartEvent } from './global-analytics-configuration';

const overviewHierarchy = ['myaccount', 'overview'];
const notificationOptInPageName = 'modal-marketing opt-in offer';

const notificationOptInPageObject = {
  page: {
    name: notificationOptInPageName,
    hierarchy: overviewHierarchy,
    url: 'modal popup',
  },
};

const getOptInNotificationModalTrackingObject = (action: string, isInternalLinkTracking?: boolean) => ({
  ...notificationOptInPageObject,
  events: interactionEvent,
  interaction: {
    type: 'click',
    name: `${overviewHierarchy.join(':')}:${notificationOptInPageName}|marketing opt-in banner|${action}`,
  },
  ...(isInternalLinkTracking ? { isInternalLinkTracking } : {}),
});

// Mappings for analytics fired inside modals opened via ModalService.
// The modal is rendered in AppComponent's ViewContainerRef (see ViewContainerRefService),
// so it only has access to the root injector — not the OverviewModule injector.
export const coreAnalyticsConfiguration: AnalyticsConfiguration = {
  mappings: {
    loadNotificationModal: {
      ...notificationOptInPageObject,
      events: pageViewEvent,
    },
    closeNotificationModal: getOptInNotificationModalTrackingObject('close'),
    clickSignUpNotificationModal: getOptInNotificationModalTrackingObject('signup'),
    clickLaterNotificationModal: getOptInNotificationModalTrackingObject('maybe later'),
    clickPrivacyPolicyNotificationModal: getOptInNotificationModalTrackingObject('fido privacy policy', true),
    signUpNotificationModalStart: {
      ...notificationOptInPageObject,
      events: selfServeStartEvent,
      selfServe: {
        name: 'marketing opt-in sign up',
        type: 'transaction',
      },
    },
  },
};
